export default {
  // Page title
  'page.title': 'Таймер',

  // Popular timers
  'popular.title': 'Популярные Таймеры',
  'popular.10s': 'Таймер на 10 Секунд',
  'popular.20s': 'Таймер на 20 Секунд',
  'popular.30s': 'Таймер на 30 Секунд',
  'popular.40s': 'Таймер на 40 Секунд',
  'popular.50s': 'Таймер на 50 Секунд',
  'popular.90s': 'Таймер на 1,5 Минуты',
  'popular.2minute': 'Таймер на 2 Минуты',
  'popular.3minute': 'Таймер на 3 Минуты',
  'popular.5minute': 'Таймер на 5 Минут',
  'popular.10minute': 'Таймер на 10 Минут',
  'popular.15minute': 'Таймер на 15 Минут',
  'popular.30minute': 'Таймер на 30 Минут',
  'popular.60minute': 'Таймер на 60 Минут',
  'popular.1hour': 'Таймер на 1 Час',
  'popular.10hour': 'Таймер на 10 Часов',
  'popular.24hour': 'Таймер на 24 Часа',
  'popular.48hour': 'Таймер на 48 Часов',

  // How to use
  'howto.title': 'Как Настроить Таймер',
  'howto.titleMinutes': 'Как Настроить Таймер на {{minutes}} Минут',
  'howto.titleSeconds': 'Как Настроить Таймер на {{seconds}} Секунд',
  'howto.titleHour': 'Как Настроить Таймер на {{hours}} Час',
  'howto.titleHours': 'Как Настроить Таймер на {{hours}} Часов',
  'howto.step1': '⚙️ Установите Время: Нажмите на цифры часов или минут для прямого редактирования времени. Вы можете установить до 23 часов и 59 минут для любой задачи.',
  'howto.step2': '⚡ Быстрая Настройка: Используйте удобные кнопки быстрого добавления, чтобы мгновенно добавить 30 секунд, 1 минуту, 5 минут, 10 минут или 30 минут к вашему таймеру.',
  'howto.step3': '▶️ Запуск и Управление: Нажмите "Старт" для начала обратного отсчета. Вы можете поставить на паузу в любое время для перерыва и возобновить, когда будете готовы, или сбросить для повторного запуска.',
  'howto.step4': '🔔 Получайте Уведомления: Получайте уведомления на рабочий стол и настраиваемые звуковые сигналы по окончании времени. Включайте/выключайте звук в правом верхнем углу.',
  'howto.step5': '🖥️ Полноэкранный Режим: Нажмите кнопку полноэкранного режима для хронометража без отвлечений - идеально для презентаций, медитации или сфокусированных рабочих сессий.',
  'howto.step6': '📱 Работает Везде: Используйте на любом устройстве - компьютере, планшете или мобильном телефоне. Не требует загрузки, работает прямо в вашем браузере.',

  // User review submission
  'reviewSubmission.title': 'Поделитесь Своим Опытом',
  'reviewSubmission.subtitle': 'Помогите другим узнать об этом таймере, поделившись своим опытом',
  'reviewSubmission.ratingLabel': 'Оцените свой опыт',
  'reviewSubmission.commentLabel': 'Ваш отзыв (необязательно)',
  'reviewSubmission.commentPlaceholder': 'Расскажите нам, как этот таймер помог вам в продуктивности, готовке, учебе или других занятиях...',
  'reviewSubmission.nameLabel': 'Ваше имя (необязательно)',
  'reviewSubmission.namePlaceholder': 'Как нам отображать ваше имя?',
  'reviewSubmission.submitButton': 'Отправить Отзыв',
  'reviewSubmission.thankYou': 'Спасибо за ваш отзыв!',
  'reviewSubmission.thankYouMessage': 'Ваши отзывы помогают нам улучшаться и помогают другим узнать о нашем таймере.',
  'reviewSubmission.error': 'Пожалуйста, выберите оценку перед отправкой.',

  // User reviews
  'reviews.title': 'Что Говорят Наши Пользователи',
  'reviews.newReview': 'Новый Отзыв',
  'reviews.mikeZhang': 'Революция для моей продуктивности! Техника Помодоро с этим таймером помогла мне закончить диссертацию. Чистый интерфейс, никаких отвлечений.',
  'reviews.lisaLee': 'Идеален для приготовления на кухне! Больше никаких переваренных яиц. Звуковые сигналы достаточно громкие, но не раздражающие. Моя пожилая мама тоже в восторге.',
  'reviews.johnDeveloper': 'Лучший таймер для перерывов в программировании! Предустановленные кнопки экономят массу времени. Помогает предотвратить усталость глаз и поддерживает концентрацию во время спринтов.',
  'reviews.msChen': 'Преобразил управление моим классом! Теперь ученики действительно любят занятия с таймером. Визуальный обратный отсчет держит всех вовлеченными.',
  'reviews.fitnessPro': 'Революционен для HIIT-тренировок! Точный хронометраж, удобное управление даже влажными руками. Мои клиенты обожают полноэкранный режим.',
  'reviews.sarahMarketer': 'Повысил эффективность моих встреч на 40%! Больше никаких бесконечных обсуждений. Временные ограничения заставляют принимать решения и удерживают всех сфокусированными.',
  'reviews.tomChef': 'Незаменим на кухне моего ресторана! Паста, стейки, соусы - идеальный хронометраж каждый раз. Множественные кнопки быстрого добавления - гениальны.',
  'reviews.amyStudent': 'Прорыв в учебе! Разбивает цикл прокрастинации на управляемые временные отрезки. Перешла с троек на пятерки благодаря этому методу.',
  'reviews.davidWriter': 'Вылечил мой писательский блок! 15-минутные письменные спринты создают импульс. Опубликовал 3 статьи в этом месяце благодаря этому таймеру.',
  'reviews.rachelTherapist': 'Идеален для медитационных сессий с клиентами. Мягкие сигналы не нарушают умиротворенную атмосферу. Очень профессионально.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'Незаменим для офисной работы! Идеален для заваривания чая и перерывов между встречами, чистый интерфейс не отвлекает от работы.',
  'reviews.mrsLi': 'Идеальный таймер для яиц! Яйца всмятку на 3 минуты получаются идеальными каждый раз, звуковые сигналы очень продуманы, никаких переваренных яиц.',
  'reviews.programmerWang': 'Необходим для упражнений для глаз во время перерывов в программировании, 3 минуты - как раз достаточно для расслабления глазных мышц, отлично для защиты зрения!',

  // Use cases
  'useCases.title': 'Варианты Использования Таймера на {{minutes}} Минут',
  'useCases.titleSeconds': 'Варианты Использования Таймера на {{seconds}} Секунд',
  'useCases.titleHours': 'Варианты Использования Таймера на {{hours}} Часов',

  // Page titles
  'pageTitle': 'Таймер на {{minutes}} Минут',
  'pageTitleSeconds': 'Таймер на {{seconds}} Секунд',
  'pageTitleHour': 'Таймер на {{hours}} Час',
  'pageTitleHours': 'Таймер на {{hours}} Часов',

  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee',
  'user.johnDeveloper': 'John Разработчик',
  'user.msChen': 'Г-жа Chen',
  'user.fitnessPro': 'Фитнес Про',
  'user.sarahMarketer': 'Sarah Маркетолог',
  'user.tomChef': 'Шеф Tom',
  'user.amyStudent': 'Amy Студентка',
  'user.davidWriter': 'David Писатель',
  'user.rachelTherapist': 'Rachel Терапевт',
  // Preset timer specific users
  'user.managerZhang': 'Менеджер Zhang',
  'user.mrsLi': 'Г-жа Li',
  'user.programmerWang': 'Программист Wang',

  // Use cases
  'useCases.quickBreak.title': 'Быстрый Перерыв',
  'useCases.quickBreak.desc': 'Короткий перерыв между рабочими сессиями для освежения ума и предотвращения выгорания',
  'useCases.eyeCare.title': 'Напоминание о Защите Глаз',
  'useCases.eyeCare.desc': 'Следуйте правилу 20-20-20: каждые 20 минут смотрите на объект в 6 метрах в течение 20 секунд',
  'useCases.teaBrewing.title': 'Заваривание Чая',
  'useCases.teaBrewing.desc': 'Идеальное время заваривания для зеленого чая (3 мин), черного чая (5 мин) или травяных смесей',
  'useCases.lightExercise.title': 'Легкие Упражнения',
  'useCases.lightExercise.desc': 'Офисная растяжка, йога за столом или простые упражнения для борьбы с сидячим образом жизни',
  'useCases.meditation.title': 'Осознанность и Медитация',
  'useCases.meditation.desc': 'Управляемые дыхательные упражнения, практика осознанности или медитация для снятия стресса',
  'useCases.softBoiledEggs.title': 'Кулинарный Таймер',
  'useCases.softBoiledEggs.desc': 'Идеальный хронометраж для яиц всмятку (5 мин), варки пасты или любых кухонных задач',
  'useCases.quickReading.title': 'Сфокусированное Чтение',
  'useCases.quickReading.desc': 'Концентрированные сессии чтения книг, статей или учебных материалов',
  'useCases.phoneCall.title': 'Таймер Звонков и Встреч',
  'useCases.phoneCall.desc': 'Держите телефонные звонки в рамках, ограничивайте продолжительность встреч или засекайте время презентаций',
  'useCases.focusedWork.title': 'Рабочие Сессии Помодоро',
  'useCases.focusedWork.desc': 'Классическая техника Помодоро - 25 минут сфокусированной работы с последующим перерывом',
  'useCases.exercise.title': 'Тренировки и Фитнес',
  'useCases.exercise.desc': 'Высокоинтенсивные интервалы, круговые тренировки или конкретная продолжительность упражнений',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Стендап-Встречи',
  'useCases.shortMeeting.desc': 'Быстрые обновления команды, ежедневные стендапы или короткие совместные обсуждения',
  'useCases.powerNap.title': 'Энергетический Сон',
  'useCases.powerNap.desc': 'Оптимальная продолжительность сна для прилива энергии без сонливости',
  'useCases.learning.title': 'Учебные Сессии',
  'useCases.learning.desc': 'Практика языка, обучающие уроки или образовательные видеоролики',
  'useCases.creativity.title': 'Творческие Спринты',
  'useCases.creativity.desc': 'Мозговые штурмы, письменные спринты или творческая практика',
  // 30-minute specific
  'useCases.deepWork.title': 'Глубокая Рабочая Сессия',
  'useCases.deepWork.desc': 'Продолжительная сфокусированная работа с минимальными прерываниями для сложных задач',
  'useCases.workout.title': 'Полноценная Тренировка',
  'useCases.workout.desc': 'Полная программа упражнений, йога-сессия или структурированная тренировка',
  'useCases.study.title': 'Учебный Блок',
  'useCases.study.desc': 'Интенсивные учебные сессии для экзаменов, исследований или развития навыков',
  'useCases.presentation.title': 'Практика Презентаций',
  'useCases.presentation.desc': 'Репетиция речей, практика питчей или хронометраж выступлений',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Офис',
  'user.developerSarah': 'Sarah Разработчик',
  'user.designerMike': 'Mike Дизайнер',
  'reviews.officeWorkerAlex': 'Идеален для быстрых перерывов между встречами! Всего 1 минута на растяжку и перефокусировку имеет огромное значение.',
  'reviews.developerSarah': 'Отлично подходит для правила 20-20-20 - каждые 20 минут я смотрю на что-то в 6 метрах в течение 1 минуты. Мои глаза чувствуют себя намного лучше!',
  'reviews.designerMike': 'Использую для микро-перерывов во время интенсивной дизайнерской работы. Коротко, но эффективно для предотвращения выгорания.',

  // 3-minute timer users
  'user.teaLoverEmily': 'Emily Чай',
  'user.yogatrainerJohn': 'John Йога',
  'user.busyMomLisa': 'Lisa Мама',
  'reviews.teaLoverEmily': 'Идеальный хронометраж для моего зеленого чая! 3 минуты дают отличный вкус без горечи. Обожаю звуковой сигнал!',
  'reviews.yogatrainerJohn': 'Использую для быстрых дыхательных упражнений с клиентами. 3 минуты - как раз для успокаивающей сессии.',
  'reviews.busyMomLisa': 'Отлично для хронометража чистки зубов моих детей. Теперь они действительно наслаждаются обратным отсчетом!',

  // 5-minute timer users
  'user.meditatorZen': 'Мастер Дзен',
  'user.chefTony': 'Шеф Tony',
  'user.runnerMia': 'Mia Бегунья',
  'reviews.meditatorZen': 'Идеален для медитации новичков. 5 минут - управляемо, но эффективно для практики осознанности.',
  'reviews.chefTony': 'Незаменим на моей кухне! Идеальный хронометраж для яиц всмятку каждый раз. Профессионально и надежно.',
  'reviews.runnerMia': 'Использую для растяжки после пробежки. 5 минут гарантируют, что я не пропущу восстановительную рутину!',

  // 10-minute timer users
  'user.studentDavid': 'David Студент',
  'user.managerRachel': 'Rachel Менеджер',
  'user.writerJames': 'James Писатель',
  'reviews.studentDavid': 'Отлично для учебных перерывов! 10 минут идеальны для ментальной перезагрузки без потери импульса.',
  'reviews.managerRachel': 'Использую для сфокусированных сессий чтения. 10 минут непрерывного чтения действительно складываются!',
  'reviews.writerJames': 'Идеален для письменных спринтов с таймером. Давление 10 минут помогает мне преодолеть писательский блок.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Консультант',
  'user.teacherBen': 'Ben Учитель',
  'user.freelancerSophie': 'Sophie Фрилансер',
  'reviews.consultantAmy': 'Идеален для быстрых звонков с клиентами и стендап-встреч. Держит обсуждения сфокусированными и продуктивными.',
  'reviews.teacherBen': 'Использую для классных занятий и групповой работы. Ученики остаются вовлеченными с временным ограничением.',
  'reviews.freelancerSophie': 'Идеальные сессии Помодоро! 15 минут сфокусированной работы с последующим перерывом держат меня продуктивной весь день.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Руководитель',
  'user.fitnessCoachMaya': 'Maya Фитнес',
  'user.artistOlivia': 'Olivia Художница',
  'reviews.executiveRobert': 'Отлично для глубоких рабочих сессий. 30 минут позволяют достичь значимого прогресса без чрезмерных обязательств.',
  'reviews.fitnessCoachMaya': 'Идеален для полных тренировочных кругов. Мои клиенты обожают структурированный хронометраж для разных упражнений.',
  'reviews.artistOlivia': 'Отлично для творческих сессий. 30 минут дают достаточно времени, чтобы войти в состояние потока и создать что-то значимое.',
};